import React, { useEffect, useState } from "react";
import { Box, Typography, Tooltip } from "@mui/material";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ModeCommentOutlinedIcon from "@mui/icons-material/ModeCommentOutlined";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import ShareIcon from "@mui/icons-material/Share";
import { useLocation } from "react-router-dom";
import axios from "axios";
import ShareModal from "./ShareModal";
import { styled } from "@mui/material/styles";
import { GetUserId } from "./HelperFunctions";
import { BASE_URL } from "../config/network/ApiUrl";

const ActionSidebar = ({
    onComment,
    commentCountData
}) => {
    const [open, setOpen] = useState(false);
    const [data, setData] = useState({ items: [{ field_release_date: "September 29, 2025" }] });
    const [likeData, setLikeData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [feedbackOpen, setFeedbackOpen] = useState(false); // 👈 For feedback modal
    const location = useLocation();
    const [shareOpen, setShareOpen] = useState(false);
    const [shareData, setShareData] = useState(null);
    const [liked, setLiked] = useState(false);
    const storydata = location?.state?.story;
    const allStories = location?.state?.data;

    console.log("storydata in ActionSidebar", storydata)
    console.log("commentCountData", commentCountData)





    // 🟢 Fetch initial like state when page loads
    useEffect(() => {
        if (!storydata?.id) return;
        const fetchLikes = async () => {
            try {
                const res = await axios.get(
                    `${BASE_URL}api/node/${storydata?.id}/like?google_user_id=${GetUserId()}&refresh=${new Date().getTime()}`
                );
                console.log("get like data", res)
                setLikeData(res?.data);
                setLiked(res?.data?.user_reaction === "like");
            } catch (err) {
                console.error("Error fetching like data:", err);
            }
        };
        fetchLikes();
    }, [storydata?.id]);

    const handleShare = async () => {
        setLoading(true);
        try {
            const res = await axios.get(`${BASE_URL}api/share/${storydata?.id}`);
            console.log("Share API response", res)
            setShareData(res.data);
            setShareOpen(true);
        } catch (err) {
            console.error("Error fetching share data:", err);
        } finally {
            setLoading(false);
        }
    };


    const handleLike = async () => {
        //  if (!storydata?.id) return;
        const body = {
            action: liked ? "remove" : "like",
            google_user_id: GetUserId()
        };
        console.log("body", body)
        // setLoading(true);
        try {
            const res = await axios.post(`${BASE_URL}api/node/${storydata?.id}/like`, body);
            console.log("Like API response", res)
            // ✅ Update UI based on response
            setLikeData(res?.data ? res?.data : []);
            setLiked(res?.data?.user_reaction === "like");
        } catch (err) {
            console.log("error", err)
            console.error(err);
        } finally {
            // setLoading(false);
        }
    };


    const BlackTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} />
    ))(() => ({
        [`& .MuiTooltip-tooltip`]: {
            backgroundColor: "#000",
            color: "#fff",
            fontSize: "12px",
            padding: "6px 10px",
            borderRadius: "4px",
        },
        [`& .MuiTooltip-arrow`]: {
            color: "#000",
        },
    }));


    const CommentSvgIcon = ({ size = 30, color = "#000" }) => {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                version="1.1"
                id="Layer_1"
                x="0px"
                y="0px"
                width={size}
                height={size}
                viewBox="492.495 171.963 1042.982 898.074"
                enableBackground="new 492.495 171.963 1042.982 898.074"
                xmlSpace="preserve"
                className="svg replaced-svg"
            >
                <path d="M1519.116,208.467l-20.142-20.142c-21.844-21.816-57.349-21.816-79.191,0l-349.164,349.164  
        c-2.268,2.295-3.969,5.103-4.887,8.208l-30.213,102.113c-1.998,6.831-0.136,14.176,4.887,19.197  
        c5.021,5.022,12.365,6.885,19.197,4.887l102.113-30.213c3.105-0.891,5.913-2.592,8.208-4.887l349.191-349.191  
        C1540.932,265.815,1540.932,230.283,1519.116,208.467z M1104.045,618.354c-3.699-6.183-8.829-11.285-14.958-14.984l12.394-41.985  
        l44.522,44.523L1104.045,618.354z M1491.711,260.253l-22.814,22.842l-44.523-44.55l22.815-22.815c6.723-6.723,17.657-6.723,24.381,0  
        l20.142,20.142C1498.434,242.568,1498.434,253.53,1491.711,260.253z"></path>
                <rect x="715.785" y="744.147" width="479.466" height="54"></rect>
                <polygon points="715.785,415.962 715.785,469.962 1061.817,469.962 1115.79,415.962 "></polygon>
                <path d="M999.285,580.041h-332.1v54h316.224c0.135-0.54,0.188-1.026,0.351-1.566L999.285,580.041z"></path>
                <path d="M1364.514,607.041c0,184.14-183.465,333.99-408.996,333.99c-60.129,0-118.179-10.53-172.557-31.267  
        c-9.045-3.456-19.224-1.782-26.73,4.32l-87.992,71.982V857.115c0-7.857-3.43-15.31-9.396-20.466  
        c-72.44-62.425-112.347-143.938-112.347-229.608c0-184.167,183.465-333.99,408.996-333.99c89.451,0,172.206,23.625,239.598,63.559  
        l39.123-39.124c-77.598-49.194-174.149-78.435-278.721-78.435c-255.285,0-462.996,174.042-462.996,387.99  
        c0,97.794,43.119,190.458,121.716,262.197v173.799c0,10.449,6.021,19.926,15.444,24.408c3.672,1.728,7.641,2.592,11.556,2.592  
        c6.129,0,12.177-2.052,17.091-6.103l120.204-98.334c56.214,19.549,115.668,29.431,176.985,29.431  
        c255.285,0,462.996-174.042,462.996-387.99c0-41.796-8.02-82.026-22.681-119.799l-42.471,42.498  
        C1360.572,554.58,1364.514,580.446,1364.514,607.041z"></path>
            </svg>
        );
    };

    return (
        <>
        <Box
    sx={{
        width: 55,
        background: "#f5f5f5ff",
        borderRadius: 2,
        padding: "10px 10px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 1.2,
        boxShadow: 0.4,

        /* DESKTOP FIXED */
        position: "fixed",
        top: "350px",
        left: "85px",

        /* ============================
           📱 MOBILE — NOT FIXED
        ============================ */
        "@media (max-width: 600px)": {
            position: "static",      // <-- remove fixed
            width: "90%",           // full width inside layout
            padding: "10px 0",
            marginTop: 2,
            float:"right",
            flexDirection: "row",     // horizontal layout
            justifyContent: "end",
            alignItems: "center",
            gap: 0,
        }
    }}
>


                {/* LIKE */}
                <BlackTooltip title="Like" placement="right" arrow>
                    <Box
                        sx={{
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            gap: .5,
                        }}
                    >
                        {/* <FavoriteIcon sx={{ fontSize: 28, cursor: "pointer", color: liked ? "#ff6b81" : "#fff",transition: "color 0.2s", }} onClick={() => handleLike()} /> */}
                        <FavoriteBorderIcon sx={{ 
                            fontSize: "30px", "&:hover": { color: "#e31837" }, color: liked ? "#e31837" : "#000000", fontFamily: "'OpenSans-Regular'",
        "@media (max-width: 600px)": {
            marginRight:"-50px"
        } }} onClick={() => handleLike()} />
                        <Typography sx={{ cursor: "pointer", color: liked ? "#e31837" : "#000000", transition: "color 0.2s",
        "@media (max-width: 600px)": {
            marginRight:"60px"
        } }}>{likeData?.like_count}</Typography>
                    </Box>
                </BlackTooltip >

                {/* COMMENT */}
                <BlackTooltip title="Comment" placement="right" arrow >
                    <Box
                        onClick={onComment}
                        sx={{
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            gap: .5,
                            "& svg": { transition: "0.2s" },
                            "&:hover svg path, &:hover svg rect, &:hover svg polygon": {
                                fill: "#e31837",
                            },
        "@media (max-width: 600px)": {
            marginRight:"60px"
        }

                        }}
                    >
                        {/* <ModeCommentOutlinedIcon
                            sx={{
                                fontSize: 28,
                                "&:hover": {
                                    color: "#e31837",
                                },
                            }}
                        /> */}
                        <CommentSvgIcon />     
                        <Typography>{commentCountData?.total_comments? commentCountData?.total_comments:0}</Typography>
                    </Box>
                </BlackTooltip >

                {/* SHARE */}
                <BlackTooltip title="Share" placement="right" arrow>
                    <Box
                        sx={{
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            gap: .5,
                            marginLeft: "-16%"
                        }}
                    >
                        <ShareOutlinedIcon
                            onClick={handleShare}
                            sx={{
                                fontSize: "32px",
                                cursor: "pointer", "&:hover": { color: "#e31837" }

                            }}
                        />
                    </Box>
                </BlackTooltip>
            </Box>

            {/* Share Modal */}
            <ShareModal
                open={shareOpen}
                onClose={() => setShareOpen(false)}
                shareData={shareData}
                loading={loading}
            />

        </>
    );
};

export default ActionSidebar;
